import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function GalleryButtons() {
  const [activeButton, setActiveButton] = useState("signup");
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      try {
        const userData = JSON.parse(storedUserData);
        if (
          userData.is_user_login === true ||
          userData.is_admin_login === true ||
          userData.is_user_login === "true" ||
          userData.is_admin_login === "true"
        ) {
          setIsLoggedIn(true);
          setRedirectUrl(userData.redirect_url || "/dashboard");
        } else {
          setIsLoggedIn(false);
        }
      } catch (e) {
        setIsLoggedIn(false);
        console.error("Invalid userData in localStorage");
      }
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleClick = (type) => {
    setActiveButton(type);
    if (type === "login") {
      navigate("/login");
    } else {
      navigate("/signup");
    }
  };

  const handleDashboardClick = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      navigate("/dashboard");
    }
  };

  // 🔥 RETURN JSX Correctly
  return (
    <>
      {isLoggedIn ? (
        <div className="flex justify-start items-center mt-4 sm:mt-6">
          <button
            onClick={handleDashboardClick}
            className="uppercase flex items-center gap-2 rounded-none btn-hover-green bg-[#156E77] text-white px-4 py-3 text-xs lg:text-[18px] transition "
          >
            <span>Go to Dashboard</span>
            <span className="icon-arrow-right">
              <ArrowRight className="w-4 h-4 transition-opacity duration-200" />
            </span>
          </button>
        </div>
      ) : (
        <div className="flex justify-start items-start gap-2 sm:gap-4 mt-4 sm:mt-6">
          {/* LOGIN Button */}
          <button
            onClick={() => handleClick("login")}
            onMouseEnter={() => setHoveredButton("login")}
            onMouseLeave={() => setHoveredButton(null)}
            className={`
              uppercase flex items-center gap-1 sm:gap-2 rounded-none no-underline transition transform scale-y-125 text-xs lg:text-[18px] lg:px-4 lg:py-3 px-2 py-2
              ${activeButton === "login" ? "bg-[#156E77] text-white" : "bg-transparent text-[#156E77]"}
              transition
            `}
          >
            LOG IN
          </button>

          {/* SIGN UP Button */}
          <button
            onClick={() => handleClick("signup")}
            onMouseEnter={() => setHoveredButton("signup")}
            onMouseLeave={() => setHoveredButton(null)}
            className={`
              uppercase flex items-center gap-1 sm:gap-2 shadow-none rounded-none no-underline transition transform scale-y-125 text-xs lg:text-[18px] lg:px-4 lg:py-3 px-2 py-2
              ${activeButton === "signup" ? "bg-[#156E77] text-white" : "bg-transparent text-[#156E77]"}
              transition btn-hover-green
            `}
          >
            <span>SIGN UP</span>
            {(activeButton === "signup" || hoveredButton === "signup") && (
              <span className="icon-arrow-right">
                <ArrowRight className="w-4 h-4" />
              </span>
            )}
          </button>
        </div>
      )}
    </>
  );
}
